<template>
  <div ref="chart" />
</template>

<script>
import dayjs from '../../core/dayjs';
import { currencyFormat } from '../../helpers/currencyFormat';
import { percentFormat } from '../../helpers/percentFormat';

export default {
  mounted () {
    this.$watch('source', () => this.generate(this.fetched));
    this.$watch('fetched', () => this.generate(this.fetched));
    this.$watch('type', () => this.generate(this.fetched));
    this.$watch('stacked', () => this.generate(this.fetched));
    this.$watch('rotated', () => this.generate(this.fetched));
  },

  props: ['fetched', 'height', 'type', 'timeseries', 'format', 'categories', 'stacked', 'legend', 'rotated', 'data', 'axis', 'ratio'],

  data () {
    return {
      chart: false,
      defaults: {
        data: {
          order: 'desc',
        },
        axis: {
          x: {
            tick: {
              centered: true,
              fit: true,
              // culling: false,
            },
          },
          y: { tick: {} },
        },
        grid: {
          x: { show: false },
          y: { show: true },
        },
        legend: { show: true, hide: false },
      },
    };
  },

  methods: {
    generate (fetched) {
      Vue.nextTick(() => {
        const options = this.getChartOptions(fetched);

        if (! this._chart || this.timeseries === false) {
          if (this._chart) {
            this._chart.destroy();
            this._chart = null;
          }

          return this._chart = window.c3.generate(options);
        }

        options.data.unload = this._chart.columns;

        this._chart.groups(options.data.groups);
        this._chart.load(options.data);
      });
    },

    getChartOptions (fetched) {
      const options = this.defaults;

      options.bindto = this.$refs.chart;
      options.data.type = this.type || fetched.options.chart.type;
      options.data.groups = [];

      if (fetched.options.chart.colors) {
        options.data.colors = fetched.options.chart.colors;
      }

      // Clone the columns
      const columns = fetched.data.columns.slice(0);

      if (options.axis.y) {
        options.axis.y.tick.format = (value) => value;
      }

      // If type is pie, remove the first element as it's the timeseries data.
      if (options.data.type === 'pie') {
        options.axis = {
          x: {
            tick: {
              centered: true,
              fit: true,
            },
          },
        };

        columns.shift();
      } else if (fetched.options.chart) {
        if (fetched.options.chart.currency) {
          options.axis.y.tick.format = (value) => currencyFormat(value);
        } else if (fetched.options.chart.percentage) {
          options.axis.y.tick.format = (value) => percentFormat(value, 1);
        }
      }

      options.data.columns = columns;

      if (this.stacked && fetched.data.groups) {
        options.data.groups = [fetched.data.groups];
      }

      if (this.timeseries) {
        options.axis.x.type = 'timeseries';
        options.axis.x.tick.format = (date) => {
          if (date) {
            return dayjs(new Date(date)).format(this.format);
          }

          return '';
        };
      } else {
        options.axis = {
          x: {
            tick: {
              centered: true,
              fit: true,
            },
          },
        };

        // If not timeseries, always category?
        options.axis.x.type = 'category';
        // options.axis.x.categories = [fetched.data.groups.shift()];
        // options.axis.x.tick.format = (tick) => tick;
        // columns.shift();
      }

      if (this.height) {
        options.size = { height: this.height };
      }

      if (this.legend === false) {
        options.legend.show = false;
      }

      if (this.rotated) {
        options.axis.rotated = true;
      }

      if (this.axis === false) {
        options.axis.x.show = false;
        // options.axis.y.show = false;
      }

      switch (this.type) {
        case 'area':
        case 'line':
        case 'spline':
          options.data.x = 'x';
          break;
        case 'bar':
          options.data.x = 'x';

          var ticks = fetched.data.columns[0].length || 0;

          if (ticks > 25) {
            options.axis.x.tick.rotate = 45;
          }

          options.bar = {
            width: {
              max: 80,
              ratio: this.ratio || 0.25,
            },
          };
          break;
      }

      return options;
    },
  },
};
</script>
